import * as React from "react";
import MovieList from "../containers/MovieList";
import Shell from "./Shell";

export class Following extends React.Component {
    public render() {
        return (
            <Shell>
                {({ mutations, queries }) =>
                    queries.getUserProfile.data && queries.getUserProfile.data.userProfile &&
                    <MovieList
                        iconTitle="user secret"
                        locationPath={"following/"}
                        user={queries.getUser.data && queries.getUser.data.user}
                        userProfile={queries.getUserProfile.data.userProfile}
                        movieListId={queries.getUserProfile.data.userProfile.followList.id} />

                }
            </Shell >);
    }
}

export default Following;



// WEBPACK FOOTER //
// ./src/containers/Following.tsx